
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./lib/bootstrap-select');
require('./lib/selectize.js');
require('./lib/fullcalendar.min.js');
require('./lib/responsive-calendar.min.js');
require('./lib/owl.carousel');
require('./lib/dataTables.select.min.js');


window.Dropzone = require('dropzone');
window.$.fn.dataTable.ext.errMode = 'none';
window.Vue = require('vue');
Vue.config.productionTip = false;
import global from './global';
import VueRouter from 'vue-router';
import moment from 'moment';
import VueProgressBar from 'vue-progressbar';
import { Form, HasError, AlertError } from 'vform';
import swal from 'sweetalert2/dist/sweetalert2.js';
import Datepicker from 'vuejs-datepicker';
// import VTooltip from 'v-tooltip';
import preLoader from './components/partial/preLoaderComponent';
import notAllowed from './components/partial/notAllowedComponent';
import testNewTemplate from './components/partial/testNewTemplateComponent';
import paymentDetail from './components/paymentDetail/paymentDetailModel';
import CompanytransactionFee from './components/transactionFee/companyWiseTransactionFee/TransactionFeeComponent'
import transactionFeeConfiguration from './components/transactionFee/sourceWiseTransactionFee/TransactionFeeConfiguration'
import SubscriptionFee from "./components/subscriptionFee/companyWiseSubscriptionFee/SubscriptionFeeComponent";
import SubscriptionFeeConfiguration from './components/subscriptionFee/sourceWiseSubscriptionFee/SubscriptionFeeConfiguration';
import ComplaintHistory from "./components/enquiry/UsersComplaints/ComplaintHistory";
import statusAnalytics from './components/enquiry/AdminComplaints/statusAnalytics'

import notFound from './components/partial/notFoundComponent';
import VueGoogleCharts from 'vue-google-charts';
// import store from '../Vuex/store/VueStore.js'

Vue.use(global);
Vue.use(VueGoogleCharts);
// vue date picker
Vue.component('datepicker', Datepicker);
//Vue Mask
import VueInputMask from "vue-inputmask"
// Add support for input mask
Vue.use(VueInputMask.default);

import VueTimepicker from 'vue2-timepicker'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
// sweet alert
window.swal = swal;
window.moment = moment;
const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
});
window.toast = toast;

// vue tooltipmonth_year
// Vue.use(VTooltip);
// VTooltip.options.autoHide = false;

// moment date formate
Vue.filter('date_format', (date) => {
    //Dec 11, 2019
    return moment(date).format('MMM D, YYYY');
});
Vue.filter('date_format_day_first', (date) => {
    //11 Dec, 2019
    return moment(date).format('D MMM, YYYY');
});
Vue.filter('month_first_format', (date) => {
    // October 24, 2019
    return moment(date).format('MMMM D, YYYY');
});
Vue.filter('Day_month_first_format', (date) => {
    // Wednesday Oct 15, 2018
    return moment(date).format('dddd MMM D, YYYY');
});
Vue.filter('month_year', (date) => {
    // Oct, 2018
    return moment(date).format('MMMM, YYYY');
});
Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});
Vue.filter('formatAmount', function (value) {
    return value = new Intl.NumberFormat().format(value);
});
Vue.filter('time_format', (date) => {
    //Dec 11, 2019
    return moment(date).format('hh:mm:ss A');
});
Vue.filter('date_time_format', (date) => {
    //Dec 11, 2019
    return moment(date).format('dddd MMM D, YYYY  hh:mm:ss A');
});

Vue.prototype.$riskRatingStatus = function(input) {
    const number = Number(input); // Typecast the input to a number

    if (isNaN(number)) {
        return "Invalid input";
    } else if (number >= 20) {
        return "High";
    } else if (number >= 10) {
        return "Medium";
    } else if (number > 0) {
        return "Low";
    } else {
        return "NA";
    }
};

Vue.prototype.$accumulatedRiskRatingStatus = function(input) {
    const number = Number(input); // Typecast the input to a number

    if (isNaN(number)) {
        return "Invalid input";
    } else if (number >= 70) {
        return "High";
    } else if (number >= 50) {
        return "Medium";
    } else if (number > 0) {
        return "Low";
    } else {
        return "NA";
    }
};

//EventBus
window.EventBus = new Vue();

// VForm
window.Form = Form;
Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);

const VueProgressBaroptions = {
    color: '#eb401f',
    failedColor: '#874b4b',
    thickness: '2px',
    transition: {
        speed: '0.5s',
        opacity: '0.9s',
        termination: 1000
    },
    autoRevert: true,
    location: 'top',
    autoFinish:true
}

Vue.use(VueProgressBar, VueProgressBaroptions)

// Vue Custom Directive
Vue.mixin({
    updated(){
        $('[data-toggle="tooltip"]').tooltip();
    },
    created(){
        $('body').on('click' , '.swal2-confirm' , function(){
            // alert('Delegate');
        });
        $('.reupload-dropdown').on('click', function(event){
            event.stopPropagation();
        });
        $('.swal2-confirm').on('click', function(event){
            // alert('asdasd');
            event.stopPropagation();
        });
    },
    destroyed(){
        $('.tooltip').tooltip('hide');
        $('.tooltip').tooltip('update');
    },
    methods : {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onlyAlphaNumeric: function(e){
            var specialKeys = new Array();
            specialKeys.push(8);  //Backspace
            specialKeys.push(9);  //Tab
            specialKeys.push(46); //Delete
            specialKeys.push(36); //Home
            specialKeys.push(35); //End
            specialKeys.push(37); //Left
            specialKeys.push(39); //Right
            var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
        if((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || keyCode == 32 || (keyCode >= 97 && keyCode <= 122) || (specialKeys.indexOf(e.keyCode) != -1 && e.charCode != e.keyCode)){
            return true;
        }else{
            e.preventDefault();
        }
        },
        can : function(permissionName){
            return axios.get('/permission/'+permissionName)
                .then((response)=> {
                    let data = response.data;
                    this.$global.company_id = data.company_id;
                    this.$global.user_id = data.user_id;
                    this.$global.user_name = data.user_name;
                    this.$global.user_company_payment_engine = data.paymentEngine;
                    this.$global.user_company = data.companyId;
                    this.$global.user_company_email = data.companyEmail;
                    this.$global.user_vr_corp = data.user_vr_corp;
                    this.$global.user_vr_balance = data.vr_balance;
                    this.$global.heirarchy_system = data.heirarchy_system;
                    this.$global.nextMaker = data.nextMaker;
                    this.$global.nextChecker = data.nextChecker;
                    this.$global.nextApprover = data.nextApprover;
                    return data;
                })
                .catch((err)=> {
                    console.log(err);
                    return false;
                });
        },
        allow : function(actionName){
            return axios.get('/allow/'+actionName)
                .then((response)=> {
                    let data = response.data;
                    this.$global.user_name = data.user_name;
                    return data;
                })
                .catch((err)=> {
                    console.log(err);
                    return false;
                });
        },
        showAlertBox : function(type,title,message, swalWidth=512){
            swal.fire({
                type: type,
                title: title,
                html: message,
                width: swalWidth
            });
            this.$Progress.finish();
        },
        showToastBox : function(type,message){
            toast.fire({
                type: type,
                title: message
            });
            this.$Progress.finish();
        },
        formatAmount : function(value){
            return value = new Intl.NumberFormat().format(value);
        },
        makeMask: function(str){
            var trailingCharsIntactCount = 4;
            str = new Array(str.length - trailingCharsIntactCount + 1).join('x') + str.slice( -trailingCharsIntactCount);
            return str;
        },
        disableButton: function(id,value,state) {
            if(state == true) {
                value = "<span class='spinner-border spinner-border-sm'></span> "+value;
            } 
            $('#'+id).attr('disabled',state); 
            $('#'+id).html(value);
        },
        generatePassword: function() {
            var specials = '!$#%@*+^=_-';
            var lowercase = 'abcdefghijklmnopqrstuvwxyz';
            var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var numbers = '0123456789';
            var all = specials + lowercase + uppercase + numbers;

            String.prototype.pick = function(min, max) {
                var n, chars = '';

                if (typeof max === 'undefined') {
                    n = min;
                } else {
                    n = min + Math.floor(Math.random() * (max - min));
                }
                for (var i = 0; i < n; i++) {
                    chars += this.charAt(Math.floor(Math.random() * this.length));
                }
                return chars;
            };
            String.prototype.shuffle = function() {
                var array = this.split('');
                var tmp, current, top = array.length;

                if (top) while (--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }

                return array.join('');
            };

            var retVal = (specials.pick(2) + lowercase.pick(8) + uppercase.pick(3)+ numbers.pick(3) ).shuffle();
            return retVal;
        },
        promptValidationErrors(error, message = ''){
            if (error.response.status === 422) {
                let errorMessages = '';
                let errors = Object.values(error.response.data.errors);
                errors = errors.flat();

                errorMessages = 'Please provide following details:' + '\n';
                $.each(errors, (key, value) => {

                    errorMessages += (key + 1) + ': ' + value + '\n';
                });
                this.showAlertBox('error', errorMessages);
            } else {
                this.showAlertBox('error', message || 'Error to load data');
            }
        }
    },

});

//Loan Types
const loanTypes = [
    { key: 'scl', value: 'Supply Chain Loan' },
    { key: 'aas', value: 'Advance Against Salary' },
    { key: 'rzl', value: 'Rozee Professional Loan' },
    { key: 'emi', value: 'QistonPay' },
    { key: 'nl', value: 'Asaan Loan' },
    { key: 'promo', value: 'Digital Lending' },
    { key: '3sl', value: 'Supply Chain Loan - 3 Months' },
    { key: 'wel', value: 'Women Education Loan' },
    { key: 'tal', value: 'Term Advance Loan' }
];

Vue.filter('loanFilter', (obj) => {
    let arr = [];
    _.forEach(obj, function(e, i){
        loanTypes.find((element) => {
            if(element.key == e){
                arr.push(element.value);
            }else{
                return '';
            }
        });
    });
    var result = arr.map(function(val) {
        return val;
    }).join(', ');
    return result;
});

//global preLoaderComponent
Vue.component('preLoader',preLoader);
Vue.component('notAllowed',notAllowed);
Vue.component('notFound',notFound);
Vue.component('paymentDetail',paymentDetail);
Vue.component('CompanytransactionFee',CompanytransactionFee);
Vue.component('transactionFeeConfiguration',transactionFeeConfiguration);
Vue.component('SubscriptionFee',SubscriptionFee);
Vue.component('SubscriptionFeeConfiguration',SubscriptionFeeConfiguration);

// complaints management
Vue.component('ComplaintHistory',ComplaintHistory);
Vue.component('statusAnalytics',statusAnalytics);
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('passport-clients',require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients',require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens',require('./components/passport/PersonalAccessTokens.vue').default);

//<passport-clients></passport-clients>
//<passport-authorized-clients></passport-authorized-clients>
//<passport-personal-access-tokens></passport-personal-access-tokens>
let components = {};
/*
*
* Super Admin Components *
*
*/

// Transaction Logs Component
components.transactionLogsComponent = require('./components/finance/transactionLogsComponent.vue').default;

// transaction fee components
components.transactionFeeComponent = require('./components/transactionFee/TransactionFee').default;
components.addCompanyWiseTransactionFeeComponent = require('./components/transactionFee/companyWiseTransactionFee/AddCompanyWiseTransactionFeeComponent.vue').default;
components.editCompanyWiseTransactionFeeComponent = require('./components/transactionFee/companyWiseTransactionFee/EditCompanyWiseTransactionFeeComponent.vue').default;
components.addSourceWiseTransactionfeeComponents = require('./components/transactionFee/sourceWiseTransactionFee/AddSourceWiseTransactionFeeConfiguration').default;
components.editSourceWiseTransactionfeeComponents = require('./components/transactionFee/sourceWiseTransactionFee/EditSourceWiseTransacionFeeConfiguration').default;
components.reconTransactionsComponent = require('./components/fundsManagement/TransactionStatus/ReconTransactionsComponent.vue').default;
components.reconTransactionsStatusComponent = require('./components/fundsManagement/TransactionStatus/TransactionRecordComponent.vue').default;
components.reconBatchListingComponent = require('./components/fundsManagement/ReconBatchListingComponent.vue').default;

//updateBatchStatus
components.batchHitReconComponent = require('./components/fundsManagement/TransactionStatus/BatchHitReconComponent.vue').default;


// subscription fee components
components.subscriptionFeeComponent = require('./components/subscriptionFee/SubscriptionFee.vue').default;

// company wise subscription fee components
components.addCompanyWiseSubscriptionFeeComponent = require('./components/subscriptionFee/companyWiseSubscriptionFee/AddCompanyWiseSubscriptionFeeComponent.vue').default;
components.editCompanyWiseSubscriptionFeeComponent = require('./components/subscriptionFee/companyWiseSubscriptionFee/EditCompanyWiseSubscriptionFeeComponent.vue').default;

// source wise subscription fee components
components.addSoureWiseSubscriptionFeeComponent = require('./components/subscriptionFee/sourceWiseSubscriptionFee/AddSourceWiseSubscriptionFeeComponent').default;
components.editSourceWiseSubscriptionFeeComponent = require('./components/subscriptionFee/sourceWiseSubscriptionFee/EditSourceWiseSubscriptionFeeComponents').default;


// Payment preference components
components.paymentPreferenceListComponent = require('./components/paymentPreference/PaymentPreferenceListComponent.vue').default;
components.addPaymentPreferenceComponent = require('./components/paymentPreference/AddPaymentPreferenceComponent.vue').default;
components.editPaymentPreferenceComponent = require('./components/paymentPreference/EditPaymentPreferenceComponent.vue').default;
components.editAllCompanyPaymentPreferenceComponent = require('./components/paymentPreference/EditAllCompanyPaymentPreferenceComponent.vue').default;

// income tax components
components.incomeTaxSlabComponent = require('./components/incomeTaxSlab/IncomeTaxSlabComponent.vue').default;
components.addIncomeTaxSlabComponent = require('./components/incomeTaxSlab/AddIncomeTaxSlabComponent.vue').default;
components.editIncomeTaxSlabComponent = require('./components/incomeTaxSlab/EditIncomeTaxSlabComponent.vue').default;
// dashboard components
components.adminDashboardComponent = require('./components/dashboard/AdminComponent.vue').default;
components.companySalaryDashboardComponent = require('./components/dashboard/CompanySalaryComponent.vue').default;
components.companyVendorDashboardComponent = require('./components/dashboard/CompanyVendorComponent.vue').default;
components.companyRetailerDashboardComponent = require('./components/dashboard/CompanyRetailerComponent').default;
components.myDashboardComponent = require('./components/dashboard/MyDashboardComponent.vue').default;
components.epDashboardComponent = require('./components/dashboard/EPDashboardComponent.vue').default;
components.epDashboardDetailsComponent = require('./components/dashboard/EPDashboardDetailsComponent.vue').default;
components.epDashboardTotalTXNComponent = require('./components/dashboard/EPDashboardTotalTXNComponent.vue').default;
// region components
components.regionsComponent = require('./components/regions/RegionsComponent.vue').default;
components.editRegionComponent = require('./components/regions/EditRegionComponent.vue').default;
components.addRegionComponent = require('./components/regions/AddRegionComponent.vue').default;
// city components
components.citiesComponent = require('./components/city/CityComponent.vue').default;
components.addCityComponent = require('./components/city/AddCityComponent.vue').default;
components.editCityComponent = require('./components/city/EditCityComponent.vue').default;
// Industry types components
components.industryTypesComponent = require('./components/riskRating/IndustryTypeComponent.vue').default;
components.addIndustryTypesComponent = require('./components/riskRating/AddIndustryTypesComponent.vue').default;
components.editIndustryTypesComponent = require('./components/riskRating/EditIndustryTypesComponent.vue').default;
// Account Purposes components
components.accountPurposesComponent = require('./components/riskRating/AccountPurposesComponent.vue').default;
components.addAccountPurposesComponent = require('./components/riskRating/AddAccountPurposesComponent.vue').default;
components.editAccountPurposesComponent = require('./components/riskRating/EditAccountPurposesComponent.vue').default;
// Account Types components
components.accountTypesComponent = require('./components/riskRating/AccountTypesComponent.vue').default;
components.addAccountTypesComponent = require('./components/riskRating/AddAccountTypesComponent.vue').default;
components.editAccountTypesComponent = require('./components/riskRating/EditAccountTypesComponent.vue').default;
// poc components
components.pocsComponent = require('./components/poc/PocComponent.vue').default;
components.addPocComponent = require('./components/poc/AddPocComponent.vue').default;
components.editPocComponent = require('./components/poc/EditPocComponent.vue').default;
// company components
components.companiesComponent = require('./components/company/CompanyComponent.vue').default;
components.allCompaniesComponent = require('./components/company/allCompaniesComponent.vue').default;
components.inactivecompaniesComponent = require('./components/company/inactiveCompanyComponent.vue').default;
components.addCompanyComponent = require('./components/company/AddCompanyComponent.vue').default;
components.editCompanyComponent = require('./components/company/EditCompanyComponent.vue').default;
// blacklist companies component
components.whitelistCompaniesComponent = require('./components/company/whitelistCompaniesComponent.vue').default;
components.blacklistCompaniesComponent = require('./components/company/blacklistCompaniesComponent.vue').default;
components.dormantCompaniesComponent = require('./components/company/DormantCompanyComponent.vue').default;




// loan Tier components
components.loanTiersComponent = require('./components/loanTier/LoanTierComponent.vue').default;
components.addLoanTierComponent = require('./components/loanTier/AddLoanTierComponent.vue').default;
components.editLoanTierComponent = require('./components/loanTier/EditLoanTierComponent.vue').default;
// roles components
components.AdminrolesComponent = require('./components/roles/AdminRolesComponent.vue').default;
components.AdmineditRoleComponent = require('./components/roles/AdminEditRoleComponent.vue').default;
components.AdminaddRoleComponent = require('./components/roles/AdminAddRoleComponent.vue').default;
// payment messages
components.PaymentMessagesComponent = require('./components/paymentMessages/PaymentMessagesComponent.vue').default;
components.AddPaymentMessageComponent = require('./components/paymentMessages/AddPaymentMessageComponent.vue').default;
components.EditPaymentMessageComponent = require('./components/paymentMessages/EditPaymentMessageComponent.vue').default;
// administrator components
components.administratorsComponent = require('./components/administrator/AdministratorsComponent.vue').default;
components.addAdministratorComponent = require('./components/administrator/AddAdministratorComponent.vue').default;
components.editAdministratorComponent = require('./components/administrator/EditAdministratorComponent.vue').default;
// super admin components
components.superAdminComponent = require('./components/superAdmin/SuperAdminComponent.vue').default;
components.addSuperAdminComponent = require('./components/superAdmin/AddSuperAdminComponent.vue').default;
components.editSuperAdminComponent = require('./components/superAdmin/EditSuperAdminComponent.vue').default;
// Finance components
components.financeLedgerReport = require('./components/finance/vrCorporateLedgerComponent.vue').default;
components.financeTransferIn = require('./components/finance/financeTransferIn.vue').default;
components.financeTransferInBulk = require('./components/finance/financeTransferInBulk.vue').default;
components.bulkTransferInComponent = require('./components/finance/BulkTransferInComponent').default;
components.viewBulkTransferInDetailsComponent = require('./components/finance/ViewBulkTransferInDetails').default;
components.financeTransferOutList = require('./components/finance/financeTransferOutList.vue').default;
components.financeTransferOutDetails = require('./components/finance/financeTransferOutDetails.vue').default;
components.financeTransferOutInBulk = require('./components/finance/financeTransferOutInBulk').default;

components.financeTransferOut = require('./components/finance/financeTransferOut.vue').default;
components.financeReversalTransfer = require('./components/finance/financeReversalTransfer.vue').default;
components.vrCompanyBalances = require('./components/finance/virtualCompanyBalances.vue').default;
components.epPoolAccountUpdate = require('./components/finance/EPPoolAccountUpdate.vue').default;
// call center Admin components
components.callCenterAdminListComponent = require('./components/callCenter/CallCenterAdminListComponent.vue').default;
components.addCallCenterAdminComponent = require('./components/callCenter/AddCallCenterAdminComponent.vue').default;
components.editCallCenterAdminComponent = require('./components/callCenter/EditCallCenterAdminComponent.vue').default;
// invoice Discounting
components.callCenterInvoiceDiscountingListComponent = require('./components/invoiceDiscounting/CallCenterInvoiceDiscountingListComponent.vue').default;
components.callCenterInvoiceDiscountingDetailComponent = require('./components/invoiceDiscounting/CallCenterInvoiceDiscountingDetailComponent.vue').default;
//admin custom reporting components
components.adminCustomReportsComponent = require('./components/customreports/AdminCustomReportComponent.vue').default;
components.assignCustomReportComponent = require('./components/customreports/AssignCustomReportComponent.vue').default;
components.editCustomReportComponent = require('./components/customreports/EditCustomReportComponent.vue').default;




/*
*
* Company Side Components *
*
*/

// LedgerReport
components.ledgerReportComponent = require('./components/reports/LedgerReportComponent.vue').default;

//bill payment
components.billPaymentsComponent = require('./components/billPayment/BillPaymentsComponent.vue').default;
components.addBillPaymentComponent = require('./components/billPayment/AddBillPaymentComponent.vue').default;
components.bulkBillPaymentsComponent = require('./components/billPayment/BulkBillPaymentsComponent').default;
components.viewBillPaymentComponent = require('./components/billPayment/ViewBillPaymentComponent.vue').default;
//topup payment
components.topupsPaymentsComponent = require('./components/topupsPayment/TopupsPaymentsComponent.vue').default;
components.topupsPaymentSheetComponent = require('./components/topupsPayment/TopupsPaymentSheetComponent.vue').default;
components.topupsPaymentBulkUploadComponent= require('./components/topupsPayment/TopupsPaymentBulkUploadComponent.vue').default;
components.individualTopupsPaymentComponent= require('./components/topupsPayment/IndividualTopupsPaymentComponent.vue').default;

//finja Card
components.finjaCardComponent = require('./components/employee/EmployeeBulkUpload.vue').default;
// emmployee components
components.employeesComponent = require('./components/employee/EmployeesComponent.vue').default;
components.incompleteEmployeesComponent = require('./components/employee/IncompleteEmployeesComponent.vue').default;
components.addEmployeeBasicDetailComponent = require('./components/employee/AddEmployeeBasicDetailComponent.vue').default;
components.EmployeeBulkUploadComponent = require('./components/employee/EmployeeBulkUpload.vue').default;
components.addEmployeePersonalDetailComponent = require('./components/employee/AddEmployeePersonalDetailComponent.vue').default;
components.addEmployeeTaxDetailComponent = require('./components/employee/AddEmployeeTaxDetailComponent.vue').default;
components.addEmployeePaymentDetailComponent = require('./components/employee/AddEmployeePaymentDetailComponent.vue').default;
components.addEmployeeTimeoffComponent = require('./components/employee/AddEmployeeTimeoffComponent.vue').default;
components.addEmployeeUserPermissionComponent = require('./components/employee/AddEmployeeUserPermissionComponent.vue').default;
components.addEmployeeWelcomeComponent = require('./components/employee/AddEmployeeWelcomeComponent.vue').default;
components.editEmployeeComponent = require('./components/employee/EditEmployeeComponent.vue').default;
// Attendance components
components.employeeLeavesComponent = require('./components/attendance/EmployeeLeavesComponent.vue').default;
components.listAttendanceCorrectionComponent = require('./components/attendance/listAttendanceCorrectionComponent.vue').default;
components.attendanceTodayComponent = require('./components/attendance/attendanceTodayComponent.vue').default;
components.viewAttendanceCorrection = require('./components/attendance/viewAttendanceCorrection.vue').default;
components.employeeViewAttendanceCorrection = require('./components/attendance/employeeViewAttendanceCorrection.vue').default;
components.myAttendance = require('./components/attendance/myAttendance.vue').default;
components.myCorrection = require('./components/attendance/myCorrection.vue').default;
components.uploadBulkAttendance = require('./components/attendance/uploadBulkAttendance.vue').default;
components.attendanceIncompleteComponent = require('./components/attendance/attendanceIncomplete.vue').default;
components.attendanceHistory = require('./components/attendance/attendanceHistory.vue').default;

// employee payment components
components.employeePaymentsComponent = require('./components/employeePayment/EmployeePaymentComponent.vue').default;
components.viewEmployeePaymentBatchSheetComponent = require('./components/employeePayment/ViewEmployeePaymentBatchSheetComponent.vue').default;

// vendor component vendorsComponent
components.vendorsComponent = require('./components/vendors/vendorsComponent.vue').default;
components.incompleteVendorsComponent = require('./components/vendors/incompleteVendorComponent.vue').default;
components.addVendorComponent = require('./components/vendors/addVendorBasicDetailComponent.vue').default;
components.addVendorPersonalComponent = require('./components/vendors/addVendorPersonalDetailComponent.vue').default;
components.addVendorTaxComponent = require('./components/vendors/addVendorTaxDetailComponent.vue').default;
components.addVendorPaymentDetail = require('./components/vendors/addVendorPaymentDetailComponent.vue').default;
components.editVendorComponent = require('./components/vendors/editVendorComponent.vue').default;
components.vendorBulkUpload = require('./components/vendors/bulkUploadComponent.vue').default;
components.viewVendorComponent = require('./components/vendors/viewVendorComponent.vue').default;

//merchant component
components.editMerchantComponent = require('./components/merchants/editMerchantComponent.vue').default;
components.merchantAutoSweepComponent = require('./components/merchants/MerchantAutoSweepComponent.vue').default;
components.merchantAutoSweepPaymentComponent = require('./components/merchants/merchantAutoSweepPaymentComponent.vue').default;
components.loanAmountTransactionHistoryComponent = require('./components/fundsManagement/LoanAmountTransactionHistoryComponent.vue').default;

// vendor component vendorsComponent
components.vendorPaymentComponent = require('./components/vendorPayment/vendorPaymentComponent.vue').default;
components.addVendorPaymentComponent = require('./components/vendorPayment/addVendorPaymentComponent.vue').default;
components.viewVendorPaymentSheetComponent = require('./components/vendorPayment/vendorPaymentSheet.vue').default;
// components.viewVendorPaymentSheetComponent = require('./components/vendorPayment/vendorPaymentSheetComponent.vue').default;
components.vendorPaymentBulkUpload = require('./components/vendorPayment/vendorPaymentBulkUpload.vue').default;

// Retailer Components
components.retailerPaymentComponent = require('./components/retailerPayment/retailerPaymentComponent.vue').default;
// components.addRetailerPaymentComponent = require('./components/retailerPayment/addRetailerPaymentComponent.vue').default;
components.viewRetailerPaymentSheetComponent = require('./components/retailerPayment/retailerPaymentSheetComponent.vue').default;
components.retailerPaymentBulkUpload = require('./components/retailerPayment/retailerPaymentBulkUpload.vue').default;
components.retailerWhitelistComponent = require('./components/retailerPayment/retailerWhitelistComponent.vue').default;

// Leaves components
components.leavesComponent =  require('./components/leaves/leavesComponent.vue').default;
components.applyLeaveComponent =  require('./components/leaves/applyLeaveComponent.vue').default;
components.companyLeavesComponent = require('./components/leaves/companyLeavesComponent.vue').default;
components.addCompanyLeaveComponent = require('./components/leaves/addCompanyLeaveComponent.vue').default;
components.editCompanyLeaveComponent = require('./components/leaves/editCompanyLeaveComponent.vue').default;
components.viewLeaveApplication = require('./components/leaves/viewLeaveApplication.vue').default;

// Partial Leaves Components
components.companyPartialLeavesComponent = require('./components/leaves/companyPartialLeavesComponent.vue').default;
components.addCompanyPartialLeavesComponent = require('./components/leaves/addCompanyPartialLeaveComponent.vue').default;
components.editCompanyPartialLeavesComponent = require('./components/leaves/editCompanyPartialLeaveComponent.vue').default;


// Company setting
components.CompanyProfileComponent = require('./components/company/CompanyProfileComponent.vue').default;

// branch components
components.branchesComponent = require('./components/branch/BranchComponent.vue').default;
components.addBranchComponent = require('./components/branch/AddBranchComponent.vue').default;
components.editBranchComponent = require('./components/branch/EditBranchComponent.vue').default;

// department components
components.departmentsComponent = require('./components/department/DepartmentComponent.vue').default;
components.addDepartmentComponent = require('./components/department/AddDepartmentComponent.vue').default;
components.editDepartmentComponent = require('./components/department/EditDepartmentComponent.vue').default;

// designation components
components.designationsComponent = require('./components/designation/DesignationComponent.vue').default;
components.addDesignationComponent = require('./components/designation/AddDesignationComponent.vue').default;
components.editDesignationComponent = require('./components/designation/EditDesignationComponent.vue').default;
components.addEditDesinationsMapping = require('./components/designation/AddEditDesignationsMapping.vue').default;

// vendor category components
components.vendorCategoriesComponent = require('./components/vendorCategory/VendorCategoryComponent.vue').default;
components.addVendorCategoryComponent = require('./components/vendorCategory/AddVendorCategoryComponent.vue').default;
components.editVendorCategoryComponent = require('./components/vendorCategory/EditVendorCategoryComponent.vue').default;

//Loan
components.activeLoanComponent = require('./components/loan/activeLoanComponent.vue').default;
components.loanDetailComponent = require('./components/loan/loanDetailComponent.vue').default;

/* Employee Side Components */
components.myPaymentComponent = require('./components/employeeProfile/MyPaymentComponent.vue').default;
components.myLoanComponent = require('./components/employeeProfile/MyLoanComponent.vue').default;
components.myLeaveComponent = require('./components/employeeProfile/MyLeaveComponent.vue').default;

// shifts
components.shiftsComponent = require('./components/shifts/shiftsComponent.vue').default;
components.addShiftsComponent = require('./components/shifts/addShiftsComponent.vue').default;

//New Shifts
components.ListNewShiftsComponent = require('./components/newshift/ListComponent.vue').default;

// Shift Requets
components.AssignShiftsComponent = require('./components/newShiftRequest/CreateComponent.vue').default;
components.ShowDetailComponent = require('./components/newShiftRequest/ShowDetailsComponent.vue').default;
components.shiftUserDetails = require('./components/newShiftRequest/ShiftUserDetailsComponent.vue').default;


// roles components
components.rolesComponent = require('./components/roles/RolesComponent.vue').default;
components.editRoleComponent = require('./components/roles/EditRoleComponent.vue').default;
components.addRoleComponent = require('./components/roles/AddRoleComponent.vue').default;

// reports components
components.employeeBatchReportComponent = require('./components/reports/EmployeeBatchReportComponent.vue').default;
components.vendorBatchReportComponent = require('./components/reports/VendorBatchReportComponent.vue').default;
components.billBatchReportComponent = require('./components/reports/BillBatchReportComponent.vue').default;
components.topupBatchReportComponent = require('./components/reports/TopupBatchReportComponent.vue').default;
components.employeeReportComponent = require('./components/reports/EmployeeReportComponent.vue').default;
components.vendorReportComponent = require('./components/reports/VendorReportComponent.vue').default;
components.attendanceReportComponent = require('./components/reports/AttendanceReportComponent.vue').default;
components.leaveReportComponent = require('./components/reports/LeaveReportComponent.vue').default;
components.feeVouchersReportComponent = require('./components/reports/feeVouchersReportComponent.vue').default;
components.externalFeeVouchersReportComponent = require('./components/reports/externalFeeVouchersReportComponent.vue').default;
components.customExternalFeeVouchersReportComponent = require('./components/reports/customExternalFeeVouchersReportComponent.vue').default;
components.misReportComponent = require('./components/reports/misReportComponent').default;
components.externalMISReportComponent = require('./components/reports/externalMISReportComponent').default;
components.externalViewReportDetailComponent = require('./components/reports/externalViewReportDetailComponent').default;
components.customExternalMISReportComponent = require('./components/reports/customExternalMISReportComponent').default;
components.customExternalViewReportDetailComponent = require('./components/reports/customExternalViewReportDetailComponent').default;
components.viewReportDetailsComponent = require('./components/reports/viewReportDetailsComponent').default;
components.viewBatchReportComponent = require('./components/reports/viewBatchReportComponent').default;



// team components
components.teamsComponent = require('./components/teams/TeamsComponent.vue').default;
components.editTeamComponent = require('./components/teams/EditTeamComponent.vue').default;
components.addTeamComponent = require('./components/teams/AddTeamComponent.vue').default;
components.addTeamMembersComponent = require('./components/teams/AddTeamMembersComponent.vue').default;
components.addTeamConfirmationComponent = require('./components/teams/AddTeamConfirmationComponent.vue').default;

// auto generate payment components
components.autoGeneratePaymentComponent = require('./components/autoGeneratePayment/AutoGeneratePaymentComponent.vue').default;
components.autoPaymentUsersComponent = require('./components/autoGeneratePayment/AutoPaymentUsersComponent.vue').default;
components.autoPaymentTimeOffComponent = require('./components/autoGeneratePayment/AutoPaymentTimeOffComponent.vue').default;
components.autoPaymentEarningsComponent = require('./components/autoGeneratePayment/AutoPaymentEarningsComponent.vue').default;
components.autoPaymentReviewComponent = require('./components/autoGeneratePayment/AutoPaymentReviewComponent.vue').default;
components.generatePaymentBatchComponent = require('./components/autoGeneratePayment/GeneratePaymentBatchComponent').default;

// fee company components
components.feeCompaniesComponent = require('./components/company/FeeCompanyComponent.vue').default;
components.feeCompanyDashboardComponent = require('./components/company/feeCompanyDashboardComponent.vue').default;

components.addFeeCompanyComponent = require('./components/company/AddFeeCompanyComponent.vue').default;
components.editFeeCompanyComponent = require('./components/company/EditFeeCompanyComponent.vue').default;

// fee company campuses components
components.feeCampusComponent = require('./components/campus/CampusComponent.vue').default;
components.feeAddCampusComponent = require('./components/campus/AddCampusComponent.vue').default;
components.feeAddCampusStudentsComponent = require('./components/campus/AddCampusStudentsComponent.vue').default;
components.feeAddCampusConfirmationComponent = require('./components/campus/AddCampusConfirmationComponent.vue').default;
components.editFeeCampusComponent = require('./components/campus/EditCampusComponent.vue').default;
components.feeStudentsComponent = require('./components/students/FeeStudentsComponent.vue').default;
components.feeBulkUploadStudentsComponent = require('./components/students/FeeBulkUploadStudentsComponent.vue').default;
components.feeAddStudentComponent = require('./components/students/FeeAddStudentComponent.vue').default;
components.feeEditStudentComponent = require('./components/students/FeeEditStudentComponent.vue').default;
components.feeStudentEditComponent = require('./components/students/feeStudentEditComponent.vue').default;
components.feeExternalVoucherComponent = require('./components/feeExternalVoucher/FeeExternalVoucherComponent.vue').default;
components.feeExternalVoucherDetailComponent = require('./components/feeExternalVoucher/FeeExternalVoucherDetailComponent.vue').default;
components.feeVouchersComponent = require('./components/feeVoucher/FeeVouchersComponent.vue').default;
components.feeVoucherDetailComponent = require('./components/feeVoucher/FeeVoucherDetailComponent.vue').default;
components.feeBulkUploadVouchersComponent = require('./components/feeVoucher/FeeBulkUploadVouchersComponent.vue').default;

// merchant company components
components.merchantCompaniesComponent = require('./components/company/MerchantCompanyComponent.vue').default;
components.addMerchantCompanyComponent = require('./components/company/AddMerchantCompanyComponent.vue').default;
components.editMerchantCompanyComponent = require('./components/company/EditMerchantCompanyComponent.vue').default;
components.detailMerchantCompanyComponent = require('./components/company/DetailMerchantCompanyComponent.vue').default;
components.merchantPaymentsComponent = require('./components/merchantPayment/merchantPaymentComponent.vue').default;
components.generateMerchantPaymentComponent = require('./components/merchantPayment/generateMerchantPaymentComponent.vue').default;
components.addMerchantComponent = require('./components/merchantPayment/addMerchantComponent.vue').default;
components.myMerchantPaymentsComponent = require('./components/merchantPayment/myMerchantPaymentsComponent.vue').default;

components.merchantPaymentSheetComponent = require('./components/merchantPayment/merchantPaymentSheetComponent.vue').default;

// help components
components.helpFormComponent = require('./components/enquiry/UsersComplaints/HelpFormComponent.vue').default;
components.complaints = require('./components/enquiry/AdminComplaints/complaintsListingComponent.vue').default;

// user settings
components.userSettingsComponent = require('./components/users/userSettingsComponent').default;

//upload bank deposit slip 
components.uploadPaymentInvoiceComponent = require('./components/users/uploadPaymentInvoiceComponent').default;
components.PaymentSlipsShowComponent     = require('./components/users/PaymentSlipsShowComponent').default;
components.PaymentSlipsViewComponent     = require('./components/users/PaymentSlipsViewComponent').default;

// faqs settings
components.faqCategoryComponent = require('./components/faqs/FaqCategoryComponent').default;
components.addFaqCategoryComponent = require('./components/faqs/AddFaqCategoryComponent').default;
components.editFaqCategoryComponent = require('./components/faqs/EditFaqCategoryComponent').default;
components.faqComponent = require('./components/faqs/FaqComponent').default;
components.addFaqComponent = require('./components/faqs/AddFaqComponent').default;
components.editFaqComponent = require('./components/faqs/EditFaqComponent').default;

// funds management
components.transactionHistoryComponent = require('./components/fundsManagement/finca/TransactionHistoryComponent').default;
components.transferInComponent = require('./components/fundsManagement/finca/TransferInComponent').default;
components.transferOutComponent = require('./components/fundsManagement/finca/TransferOutComponent').default;
components.corporateChangePasswordComponent = require('./components/fundsManagement/finca/CorporateChangePasswordComponent').default;
components.corporateLoginComponent = require('./components/fundsManagement/finca/CorporateLoginComponent').default;
//components.virtualCorporateCredit = require('./components/fundsManagement/VirtualCorporateCreditComponent').default; // Don't open it
components.corporateBillPaymentLedger = require('./components/fundsManagement/corporateBillPaymentLedger').default;
components.manageMetaDataComponent = require('./components/manageMetaData/MetaDataComponent').default;
components.addmanageMetaDataComponent = require('./components/manageMetaData/AddMetaDataComponent').default;
components.editmanageMetaDataComponent = require('./components/manageMetaData/EditMetaDataComponent').default;
components.logshippingComponent = require('./components/logShipping/LogShippingComponent').default;
components.addlogshippingComponent = require('./components/logShipping/AddLogShippingComponent').default;
components.editlogshippingComponent = require('./components/logShipping/EditLogShippingComponent').default;
components.loanAmountLedger = require('./components/fundsManagement/LoanAmountLedgerComponent').default;
components.virtualCorporateTransactionHistory = require('./components/fundsManagement/VirtualCorporateTransactionHistoryComponent').default;
components.collectionTransactionHistory = require('./components/fundsManagement/CollectionTransactionHistoryComponent').default;
components.customCollectionTransactionHistory = require('./components/fundsManagement/CustomCollectionTransactionHistoryComponent').default;
components.corporateTransactionHistory = require('./components/fundsManagement/CorporateTransactionHistoryComponent').default;


//Account Management
components.accountLinkingComponent = require('./components/accountManagement/meezan/accountLinkingComponent').default;
components.accountReLinkingComponent = require('./components/accountManagement/meezan/accountReLinkingComponent').default;
components.createMpinComponent = require('./components/accountManagement/meezan/createMpinComponent').default;
components.accountSettingComponent = require('./components/accountManagement/meezan/accountSettingComponent').default;
components.changeMpinComponent = require('./components/accountManagement/meezan/changeMpinComponent').default;
components.resetMpinComponent = require('./components/accountManagement/meezan/resetMpinComponent').default;
components.afterResetMpinComponent = require('./components/accountManagement/meezan/afterResetMpinComponent').default;
components.delinkAccountComponent = require('./components/accountManagement/meezan/delinkAccountComponent').default;
components.accountLinkingSuccessComponent = require('./components/accountManagement/meezan/accountLinkingSuccessComponent').default;

// Notifications
components.viewAllNotificationComponent = require('./components/notifications/ViewAllNotificationComponent.vue').default;

// Collection
components.addCollectionCompany = require('./components/company/addCollectionCompanyComponent').default;
components.editCollectionCompany = require('./components/company/editCollectionCompanyComponent').default;

// Performance Management System
components.pmsComponent = require('./components/modules/pms/pmsComponent').default;

// Org Chart
components.orgChartComponent = require('./components/company/OrgChartComponent').default;

// Credit In NIFT Integration 
components.creditInComponent = require('./components/fundsManagement/CreditIn/CreditInComponent').default;

//Wholesaler / Distributor
components.priceListComponent = require('./components/distributorManagement/priceListComponent').default;
components.addProductComponent = require('./components/product/AddProductComponent.vue').default;
components.editProductComponent = require('./components/product/EditProductComponent.vue').default;
components.bulkAddProductsComponent = require('./components/product/BulkAddProductsComponent').default;

//Shop
components.shopComponent = require('./components/shop/shopComponent').default;
components.addShopComponent = require('./components/shop/addShopComponent').default;
components.editShopComponent = require('./components/shop/editShopComponent').default;
components.bulkAddShopsComponent = require('./components/shop/BulkAddShopsComponent').default;

// Order
components.orderComponent = require('./components/order/orderComponent').default;
components.orderDetailsComponent = require('./components/order/orderDetailsComponent').default;

//Corporate Card
components.corporateCardComponent = require('./components/corporateCards/CorporateCardComponent').default;

//GreenLine Card
components.greenCardComponent = require('./components/corporateCards/greenCardComponent').default;

// Fixed Term Loan
components.fixedTermLoanComponent = require('./components/corporateCards/fixedTermLoanComponent').default;

// Expense Payemnts
components.expensePaymentComponent = require('./components/expensePayment/expensePaymentComponent.vue').default;
components.expenseCategoriesComponent = require('./components/expensePayment/expenseCategoriesComponent.vue').default;
components.addExpenseCategoryComponent = require('./components/expensePayment/addExpenseCategoryComponent.vue').default;
components.editExpenseCategoryComponent = require('./components/expensePayment/editExpenseCategoryComponent.vue').default;

components.viewAllReceiptsComponent = require('./components/expensePayment/viewAllReceiptsComponent.vue').default;

// transaction fee components
components.onboardingDocumentsComponent = require('./components/onboardingDocuments/onboardingDocumentsComponent.vue').default;
components.addOnboardingDocumentsComponent = require('./components/onboardingDocuments/AddOnboardingDocumentsComponent.vue').default;
components.editOnboardingDocumentsComponent = require('./components/onboardingDocuments/EditOnboardingDocumentsComponent.vue').default;

//New onboarding
components.addNewCompanyComponent = require('./components/company/AddNewCompanyComponent.vue').default;
components.companyDocumentsComponent = require('./components/company/companyDocumentsComponent.vue').default;
components.onboardingCompanyUsersComponent = require('./components/company/onboardingCompanyUsersComponent.vue').default;

//Edit onboarding Company
components.editOnboardedCompanyComponent = require('./components/company/new_onboarding/editOnboardedCompanyComponent.vue').default;
components.editOnboardedCompanyDocumentsComponent = require('./components/company/new_onboarding/editOnboardedCompanyDocumentsComponent.vue').default;
components.editOnboardedCompanyUsersComponent = require('./components/company/new_onboarding/editOnboardedCompanyUsersComponent.vue').default;

components.companyDetailedViewComponent = require('./components/company/new_onboarding/companyDetailedViewComponent.vue').default;


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VueRouter);

let routes = [
    /*
    *
    * Super Admin routes
    *
    */
    // dasnboard route
    {path: '*', component: notFound},


    {path: '/not', component: notAllowed}, // this is for testing only.
    {path:"/paymentDetail", component: paymentDetail},
    {path: '/testNewTemplate', component: testNewTemplate}, // this is for testing only.
    {path: '/adminDashboard', component: components.adminDashboardComponent},
    {path: '/companySalaryDashboard', component: components.companySalaryDashboardComponent},
    {path: '/companyVendorDashboard', component: components.companyVendorDashboardComponent},
    {path: '/companyRetailerDashboard', component: components.companyRetailerDashboardComponent},
    {path: '/myDashboard', component: components.myDashboardComponent},
    {path: '/epDashboard', component: components.epDashboardComponent},
    {path: '/epDashboard/:companyId/:companyName', component: components.epDashboardDetailsComponent},
    {path: '/epFinjaDashboard', component: components.epDashboardTotalTXNComponent},
    // transaction fee routes
    {path: '/transactionFee', component: components.transactionFeeComponent},
    {path: '/addCompanyWiseTransactionFeeComponent', component: components.addCompanyWiseTransactionFeeComponent},
    {path: '/editCompanyWiseTransactionFeeComponent/:id', component: components.editCompanyWiseTransactionFeeComponent},
    {path: '/addSourceWiseTransactionfeeComponents', component: components.addSourceWiseTransactionfeeComponents},
    {path: '/editSourceWiseTransactionfeeComponents/:id', component: components.editSourceWiseTransactionfeeComponents},
    {path: '/reconTransactions', component: components.reconTransactionsComponent},
    {path: '/transActionStatus', component: components.reconTransactionsStatusComponent},
    {path: '/reconBatchList/:id', component: components.reconBatchListingComponent},


    // batchUpdateStatus
    {path: '/batchHitRecon', component: components.batchHitReconComponent},

    // Transaction Logs
    {path: '/transactionLogs', component: components.transactionLogsComponent},

    // subscription fee routes
    {path: '/subscriptionFee', component: components.subscriptionFeeComponent},
    {path: '/addCompanyWiseSubscriptionFeeComponent', component: components.addCompanyWiseSubscriptionFeeComponent},
    {path: '/editCompanyWiseSubscriptionFeeComponent/:id', component: components.editCompanyWiseSubscriptionFeeComponent},
    {path: '/addSoureWiseSubscriptionFeeComponent', component: components.addSoureWiseSubscriptionFeeComponent},
    {path: '/editSourceWiseSubscriptionFeeComponent/:id', component: components.editSourceWiseSubscriptionFeeComponent},
    // income tax routes
    {path: '/incomeTaxSlabs', component: components.incomeTaxSlabComponent},
    {path: '/addIncomeTaxSlab', component: components.addIncomeTaxSlabComponent},
    {path: '/editIncomeTaxSlab/:id', component: components.editIncomeTaxSlabComponent},
    // region routes
    {path: '/regions', component: components.regionsComponent},
    {path: '/addRegion', component: components.addRegionComponent},
    {path: '/editRegion/:id', component: components.editRegionComponent},
    // city routes
    {path: '/cities', component: components.citiesComponent},
    {path: '/addCity', component: components.addCityComponent},
    {path: '/editCity/:id', component: components.editCityComponent},
    // industry type routes
    {path: '/industryTypes', component: components.industryTypesComponent},
    {path: '/addIndustryTypes', component: components.addIndustryTypesComponent},
    {path: '/editIndustryTypes/:id', component: components.editIndustryTypesComponent},
    // purpose of account routes
    {path: '/accountPurposes', component: components.accountPurposesComponent},
    {path: '/addAccountPurposes', component: components.addAccountPurposesComponent},
    {path: '/editAccountPurposes/:id', component: components.editAccountPurposesComponent},
    // types of account routes
    {path: '/accountTypes', component: components.accountTypesComponent},
    {path: '/addAccountTypes', component: components.addAccountTypesComponent},
    {path: '/editAccountTypes/:id', component: components.editAccountTypesComponent},
    // poc routes
    {path: '/pocs', component: components.pocsComponent},
    {path: '/addPOC', component: components.addPocComponent},
    {path: '/editPOC/:id', component: components.editPocComponent},
    // company routes
    {path: '/companies', component: components.companiesComponent},
    {path: '/allCompanies', component: components.allCompaniesComponent},
    {path: '/inactivecompanies', component: components.inactivecompaniesComponent},
    {path:'/orgchart', component: components.orgChartComponent},
    {path: '/dormantCompanies', component: components.dormantCompaniesComponent},

    //blacklist company route
    {path: '/whitelistCompanies', component: components.whitelistCompaniesComponent},
    {path: '/blacklistCompanies', component: components.blacklistCompaniesComponent},
    
    {path: '/addCompany', component: components.addCompanyComponent},
    {path: '/editCompany/:id', component: components.editCompanyComponent},
    // loan tier routes
    {path: '/loanTiers', component: components.loanTiersComponent},
    {path: '/addLoanTier', component: components.addLoanTierComponent},
    {path: '/editLoanTier/:id', component: components.editLoanTierComponent},
    // roles routes
    {path: '/listRolesAdmin', component: components.AdminrolesComponent},
    {path: '/manageAddRole', component: components.AdminaddRoleComponent},
    {path: '/manageEditRole/:id', component: components.AdmineditRoleComponent},
    // administrator routes
    {path: '/administrators', component: components.administratorsComponent},
    {path: '/addAdministrator', component: components.addAdministratorComponent},
    {path: '/editAdministrator/:id', component: components.editAdministratorComponent},
    // super admin routes
    {path: '/superAdmin', component: components.superAdminComponent},
    {path: '/addSuperAdmin', component: components.addSuperAdminComponent},
    {path: '/editSuperAdmin/:id', component: components.editSuperAdminComponent},
    // finance routes
    {path: '/financeLedgerReport', component: components.financeLedgerReport},
    {path: '/financeTransferIn', component: components.financeTransferIn},
    {path: '/financeTransferInBulk', component: components.financeTransferInBulk},
    {path: '/bulkTransferIn', component: components.bulkTransferInComponent},
    {path: '/viewBulkTransferInDetails/:id', component: components.viewBulkTransferInDetailsComponent},
    {path: '/financeTransferOut', component: components.financeTransferOut},
    {path: '/financeReversalTransfer', component: components.financeReversalTransfer},
    {path: '/vrCompanyBalances', component: components.vrCompanyBalances},
    {path: '/epPoolAccountUpdate', component: components.epPoolAccountUpdate},
    {path: '/financeTransferOutList', component: components.financeTransferOutList},
    {path: '/financeTransferOutDetails/:id', component: components.financeTransferOutDetails},
    {path: '/financeTransferOutInBulk', component: components.financeTransferOutInBulk},

    // call Center Admin routes
    {path: '/callCenterAdminList', component: components.callCenterAdminListComponent},
    {path: '/addCallCenterAdmin', component: components.addCallCenterAdminComponent},
    {path: '/editCallCenterAdmin/:id', component: components.editCallCenterAdminComponent},
    // Invoice discounting
    {path: '/callCenterInvoiceDiscountingList', component: components.callCenterInvoiceDiscountingListComponent},
    {path: '/callCenterInvoiceDiscountingDetail/:id', component: components.callCenterInvoiceDiscountingDetailComponent},
    // admin custom reporting
    {path: '/adminCustomReports', component: components.adminCustomReportsComponent},
    {path: '/assignCustomReport', component: components.assignCustomReportComponent},
    {path: '/editCustomReport/:id', component: components.editCustomReportComponent},
    // payment preference crud routes
    {path: '/paymentPreferenceList', component: components.paymentPreferenceListComponent},
    {path: '/addPaymentPreference', component: components.addPaymentPreferenceComponent},
    {path: '/editPaymentPreference/:id', component: components.editPaymentPreferenceComponent},
    {path: '/editAllCompanyPaymentPreference', component: components.editAllCompanyPaymentPreferenceComponent},



    /*
    *
    * Company Side Components
    *
    */
    //finja Card
    {path: '/finjaCard', component: components.EmployeeBulkUploadComponent},

    // employee routes
    {path: '/employees', component: components.employeesComponent},
    {path: '/incompleteEmployees', component: components.incompleteEmployeesComponent},
    {path: '/addEmployeePersonalDetail', component: components.addEmployeePersonalDetailComponent},
    {path: '/addEmployeePersonalDetail/:id', component: components.addEmployeePersonalDetailComponent},
    {path: '/addEmployeeBasicDetail/:id', component: components.addEmployeeBasicDetailComponent},
    {path: '/addEmployeeTaxDetail/:id', component: components.addEmployeeTaxDetailComponent},
    {path: '/addEmployeePaymentDetail/:id', component: components.addEmployeePaymentDetailComponent},
    {path: '/addEmployeeTimeoff/:id', component: components.addEmployeeTimeoffComponent},
    {path: '/addEmployeeUserPermission/:id', component: components.addEmployeeUserPermissionComponent},
    {path: '/addEmployeeWelcome/:id', component: components.addEmployeeWelcomeComponent},
    {path: '/editEmployee/:id', component: components.editEmployeeComponent},
    {path: '/employeeBulkUpload', component: components.EmployeeBulkUploadComponent},

    // attendance routes
    {path: '/employeeLeaves', component: components.employeeLeavesComponent},
    {path: '/listAttendanceCorrection', component: components.listAttendanceCorrectionComponent},
    {path: '/attendanceToday', component: components.attendanceTodayComponent},
    {path: '/viewAttendanceCorrection/:id', component: components.viewAttendanceCorrection},
    {path: '/employeeViewAttendanceCorrection/:id', component: components.employeeViewAttendanceCorrection},
    {path: '/uploadBulkAttendance', component: components.uploadBulkAttendance},
    {path: '/attendanceIncompletes', component: components.attendanceIncompleteComponent},
    {path: '/attendanceHistory', component: components.attendanceHistory},
    {path: '/myAttendance', component: components.myAttendance},
    {path: '/myCorrection', component: components.myCorrection},
    
    //Ledger Report
    {path: '/ledgerReport', component: components.ledgerReportComponent},


    //billpayment routes
    {path: '/billPayments', component: components.billPaymentsComponent},
    {path: '/viewBillPayment/:id', component: components.viewBillPaymentComponent},
    {path: '/addBillPayment', component: components.addBillPaymentComponent},
    {path: '/bulkBillPayments', component: components.bulkBillPaymentsComponent},
    //topup routes
    {path: '/topupsPayments', component: components.topupsPaymentsComponent},
    {path: '/viewTopupsPayment/:id', component: components.viewTopupPaymentComponent},
    {path: '/viewTopupSheet/:id', component: components.topupsPaymentSheetComponent},
    {path: '/topupBulkUpload', component: components.topupsPaymentBulkUploadComponent},
    {path: '/topupIndividualUpload', component: components.individualTopupsPaymentComponent},


    // vendors routes
    {path: '/vendors', component: components.vendorsComponent},
    {path: '/incompleteVendors', component: components.incompleteVendorsComponent},
    {path: '/addVendorBasicDetail/:id', component: components.addVendorComponent},
    {path: '/addVendorPersonalDetail', component: components.addVendorPersonalComponent},
    {path: '/addVendorPersonalDetail/:id', component: components.addVendorPersonalComponent},
    {path: '/addVendorTaxDetail/:id', component: components.addVendorTaxComponent},
    {path: '/addVendorPaymentDetail/:id', component: components.addVendorPaymentDetail},
    {path: '/vendorBulkUpload', component: components.vendorBulkUpload},
    {path: '/editVendor/:id', component: components.editVendorComponent},
    {path: '/viewVendor/:id', component: components.viewVendorComponent},

    //merchant
    {path: '/editMerchant/:id', component: components.editMerchantComponent},
    {path: '/merchantAutoSweep/:id', component: components.merchantAutoSweepComponent},
    {path: '/autoSweepPayments', component: components.merchantAutoSweepPaymentComponent},
    {path: '/loanAmountTransactionHistory', component: components.loanAmountTransactionHistoryComponent},

    // vendor payments routes
    {path: '/vendorPayment', component: components.vendorPaymentComponent},
    {path: '/generateVendorPayment', component: components.addVendorPaymentComponent},
    {path: '/viewVendorPaymentSheet/:id', component: components.viewVendorPaymentSheetComponent},
    {path: '/vendorPaymentBulkUpload', component: components.vendorPaymentBulkUpload},

    // retailer payments route
    {path: '/retailerPayment', component: components.retailerPaymentComponent},
    // {path: '/generateRetailerPayment', component: components.addRetailerPaymentComponent},
    {path: '/viewRetailerPaymentSheet/:id', component: components.viewRetailerPaymentSheetComponent},
    {path: '/retailerPaymentBulkUpload', component: components.retailerPaymentBulkUpload},
    {path: '/retailerWhitelisting', component: components.retailerWhitelistComponent},

    // employee payments routes
    {path: '/employeePayments', component: components.employeePaymentsComponent},
    {path: '/viewEmployeePaymentBatchSheet/:id', component: components.viewEmployeePaymentBatchSheetComponent},

    // leaves components
    {path: '/leaves', component: components.leavesComponent},
    {path: '/applyLeave', component: components.applyLeaveComponent},
    {path: '/companyLeaves', component: components.companyLeavesComponent},
    {path: '/addCompanyLeave', component: components.addCompanyLeaveComponent},
    {path: '/editCompanyLeave/:id', component: components.editCompanyLeaveComponent},
    {path: '/viewLeaveApplication/:id', component: components.viewLeaveApplication},
    // parial leaves components
    {path: '/companyPartialLeaves', component: components.companyPartialLeavesComponent},
    {path: '/addCompanyPartialLeave', component: components.addCompanyPartialLeavesComponent},
    {path: '/editCompanyPartialLeave/:id', component: components.editCompanyPartialLeavesComponent},

    // company Setting
    {path: '/companyProfile', component: components.CompanyProfileComponent},

    // branch routes
    {path: '/branches', component: components.branchesComponent},
    {path: '/addBranch', component: components.addBranchComponent},
    {path: '/editBranch/:id', component: components.editBranchComponent},

    // department routes
    {path: '/departments', component: components.departmentsComponent},
    {path: '/addDepartment', component: components.addDepartmentComponent},
    {path: '/editDepartment/:id', component: components.editDepartmentComponent},

    // designation routes
    {path: '/designations', component: components.designationsComponent},
    {path: '/addDesignation', component: components.addDesignationComponent},
    {path: '/editDesignation/:id', component: components.editDesignationComponent},
    {path: '/addEditDesinationsMapping', component: components.addEditDesinationsMapping},

    // vendor category routes
    {path: '/vendorCategories', component: components.vendorCategoriesComponent},
    {path: '/addVendorCategory', component: components.addVendorCategoryComponent},
    {path: '/editVendorCategory/:id', component: components.editVendorCategoryComponent},

    //Loan
    {path: '/activeLoan', component: components.activeLoanComponent},
    {path: '/loanDetail/:id', component: components.loanDetailComponent},


    /* employee profile routes */
    {path: '/myPayments', component: components.myPaymentComponent},
    {path: '/myLoan', component: components.myLoanComponent},
    {path: '/myLeaves', component: components.myLeaveComponent},

    // shifts
    {path: '/shifts', component: components.shiftsComponent},
    {path: '/addShifts', component: components.addShiftsComponent},

    //New Shifts
    {path: '/newShifts', component: components.ListNewShiftsComponent},
     // Assign Shift
    {path: '/assignShift', component: components.AssignShiftsComponent},
    {path: '/shiftDetail/:requestFor/:shiftId', component: components.ShowDetailComponent},
    {path: '/shiftDetailUsers/:requestedBy/:id/:shiftId', component: components.shiftUserDetails},



    // roles routes
    {path: '/roles', component: components.rolesComponent},
    {path: '/addRole', component: components.addRoleComponent},
    {path: '/editRole/:id', component: components.editRoleComponent},

    // report routes
    {path: '/employeePaymentReport', component: components.employeeBatchReportComponent},
    {path: '/vendorPaymentReport', component: components.vendorBatchReportComponent},
    {path: '/billPaymentReport', component: components.billBatchReportComponent},
    {path: '/topupPaymentReport', component: components.topupBatchReportComponent},
    {path: '/employeeReport', component: components.employeeReportComponent},
    {path: '/vendorReport', component: components.vendorReportComponent},
    {path: '/attendanceReport', component: components.attendanceReportComponent},
    {path: '/leaveReport', component: components.leaveReportComponent},
    
    {path: '/feeVouchersReport', component: components.feeVouchersReportComponent},
    {path: '/misReport', component: components.misReportComponent},
    {path: '/viewReportDetails/:date', component: components.viewReportDetailsComponent},
    {path: '/BatchReport', component: components.viewBatchReportComponent},

    // team routes
    {path: '/teams', component: components.teamsComponent},
    {path: '/addTeam', component: components.addTeamComponent},
    {path: '/addTeamMembers/:id', component: components.addTeamMembersComponent},
    {path: '/addTeamConfirmation/:id', component: components.addTeamConfirmationComponent},
    {path: '/editTeam/:id', component: components.editTeamComponent},

    // auto generate payment routes
    {path: '/autoGeneratePayment', component: components.autoGeneratePaymentComponent},
    {path: '/autoPaymentUsers/:id', component: components.autoPaymentUsersComponent},
    {path: '/autoPaymentTimeOff/:id', component: components.autoPaymentTimeOffComponent},
    {path: '/autoPaymentEarnings/:id', component: components.autoPaymentEarningsComponent},
    {path: '/autoPaymentReview/:id', component: components.autoPaymentReviewComponent},
    {path: '/generatePaymentBatch', component: components.generatePaymentBatchComponent},

    // fee company routes
    {path: '/feeCompanyDashboard', component: components.feeCompanyDashboardComponent},
    {path: '/feeCompanies', component: components.feeCompaniesComponent},
    {path: '/addFeeCompany', component: components.addFeeCompanyComponent},
    {path: '/editFeeCompany/:id', component: components.editFeeCompanyComponent},
    {path: '/feeCampus', component: components.feeCampusComponent},
    {path: '/feeAddCampus', component: components.feeAddCampusComponent},
    {path: '/feeAddCampusStudents/:id', component: components.feeAddCampusStudentsComponent},
    {path: '/feeAddCampusConfirmation/:id', component: components.feeAddCampusConfirmationComponent},
    {path: '/feeEditCampus/:id', component: components.editFeeCampusComponent},
    {path: '/feeStudents', component: components.feeStudentsComponent},
    {path: '/feeBulkUploadStudents', component: components.feeBulkUploadStudentsComponent},
    {path: '/feeAddStudent', component: components.feeAddStudentComponent},
    {path: '/feeEditStudent/:id', component: components.feeEditStudentComponent},
    {path: '/feeStudentEdit/:id', component: components.feeStudentEditComponent},
    {path: '/feeExternalVouchersReport', component: components.externalFeeVouchersReportComponent},
    {path: '/CustomfeeExternalVouchersReport', component: components.customExternalFeeVouchersReportComponent},
    {path: '/feeExternalVoucher', component: components.feeExternalVoucherComponent},
    {path: '/feeExternalVoucherDetail/:id', component: components.feeExternalVoucherDetailComponent},
    {path: '/feeVouchers', component: components.feeVouchersComponent},
    {path: '/feeVoucherDetail/:id', component: components.feeVoucherDetailComponent},
    {path: '/feeBulkUploadVouchers/:feeType', component: components.feeBulkUploadVouchersComponent},


    // merchant company routes
    {path: '/merchantCompanies', component: components.merchantCompaniesComponent},
    {path: '/addMerchantCompany', component: components.addmerchantCompanyComponent},
    {path: '/editMerchantCompany/:id', component: components.editMerchantCompanyComponent},
    {path: '/detailMerchantCompany/:id', component: components.detailMerchantCompanyComponent},
    {path: '/merchantPayments', component: components.merchantPaymentsComponent},
    {path: '/generateMerchantPayment', component: components.generateMerchantPaymentComponent},
    {path: '/addMerchant', component: components.addMerchantComponent},
    {path: '/merchantPaymentSheet/:id', component: components.merchantPaymentSheetComponent},
    {path: '/myMerchantPayments', component: components.myMerchantPaymentsComponent},

    // help route
    {path:'/help', component: components.helpFormComponent},
    {path:'/complaints', component: components.complaints},


    // user settings
    {path:'/userSettings', component: components.userSettingsComponent},

    // upload bank deposit slip
    {path:'/uploadPaymentInvoice', component: components.uploadPaymentInvoiceComponent},
    {path:'/PaymentSlipsShow', component: components.PaymentSlipsShowComponent},
    {path:'/viewPaymentSlips', component: components.PaymentSlipsViewComponent},

    // FAQs
    {path:'/faqsCategory', component: components.faqCategoryComponent},
    {path:'/addFaqCategory', component: components.addFaqCategoryComponent},
    {path:'/editFaqCategory/:id', component: components.editFaqCategoryComponent},
    {path:'/faqs', component: components.faqComponent},
    {path:'/addFaq', component: components.addFaqComponent},
    {path:'/editFaq/:id', component: components.editFaqComponent},
    // Funds Management
    {path:'/transactionHistory', component: components.transactionHistoryComponent},
    {path:'/transferIn', component: components.transferInComponent},
    {path:'/transferOut', component: components.transferOutComponent},
    {path:'/corporateChangePassword', component: components.corporateChangePasswordComponent},
    {path:'/corporateLogin', component: components.corporateLoginComponent},
    //{path:'/virtualCorporateCredit', component: components.virtualCorporateCredit}, // Don't open it
    {path:'/virtualCorporateTransactionHistory', component: components.virtualCorporateTransactionHistory},
    {path:'/corporateBillPaymentLedger', component: components.corporateBillPaymentLedger},


    {path:'/loanAmountLedger', component: components.loanAmountLedger},
    {path:'/collectionTransactionHistory', component: components.collectionTransactionHistory},
    {path:'/customCollectionTransactionHistory', component: components.customCollectionTransactionHistory},
    {path:'/corporateTransactionHistory', component: components.corporateTransactionHistory},

   // Manage MetaData
    {path:'/manageMetaDataComponent', component: components.manageMetaDataComponent},
    {path:'/addmanageMetaDataComponent', component: components.addmanageMetaDataComponent},
    {path:'/editmanageMetaDataComponent/:id', component: components.editmanageMetaDataComponent},

    //Log shipping Module
    {path:'/logshippingComponent', component: components.logshippingComponent},
    {path:'/addlogshippingComponent', component: components.addlogshippingComponent},
    {path:'/editlogshippingComponent/:id', component: components.editlogshippingComponent},

    // Account Management
    {path:'/accountLinking', component: components.accountLinkingComponent},
    {path:'/accountReLinking', component: components.accountReLinkingComponent},
    {path:'/createMpin', component: components.createMpinComponent},
    {path:'/accountSetting', component: components.accountSettingComponent},
    {path:'/changeMpin', component: components.changeMpinComponent},
    {path:'/resetMpin', component: components.resetMpinComponent},
    {path:'/resetMpinForm', component: components.afterResetMpinComponent},
    {path:'/delinkAccount', component: components.delinkAccountComponent},
    {path:'/accountLinkingSuccess', component: components.accountLinkingSuccessComponent},
    // External FeeVoucher MIS Report
    {path:'/externalMISReport', component: components.externalMISReportComponent},
    {path:'/externalViewReportDetail/:date', component: components.externalViewReportDetailComponent},
    // Custom External FeeVoucher MIS Report
    {path:'/customExternalMISReport', component: components.customExternalMISReportComponent},
    {path:'/customExternalViewReportDetail/:date', component: components.customExternalViewReportDetailComponent},

    // Notifications
    {path:'/viewAllNotifications', component: components.viewAllNotificationComponent},

    // Collection Company
    {path:'/addCollectionCompany', component: components.addCollectionCompany},
    {path:'/editCollectionCompany/:id', component: components.editCollectionCompany},

    // payment messages
    {path: '/paymentMessages', component: components.PaymentMessagesComponent},
    {path: '/addPaymentMessage', component: components.AddPaymentMessageComponent},
    {path: '/editPaymentMessage/:id', component: components.EditPaymentMessageComponent},

    // Performance Management System
    {path:'/pms', component: components.pmsComponent},

    //Credit In NIFT Integration
    {path:'/creditIn', component: components.creditInComponent},

    // Expense Payments
    {path:'/expensePayments', component: components.expensePaymentComponent},
    {path:'/expenseCategories', component: components.expenseCategoriesComponent},
    {path:'/addExpenseCategory', component: components.addExpenseCategoryComponent},
    {path:'/editExpenseCategory/:id', component: components.editExpenseCategoryComponent},
    {path: '/viewAllReceipts/:id', component: components.viewAllReceiptsComponent},

    //Wholesaler/ Distributor
    {path:'/priceList', component: components.priceListComponent},
    {path: '/addProduct', component: components.addProductComponent},
    {path: '/editProduct/:id', component: components.editProductComponent},
    {path: '/bulkAddProducts', component: components.bulkAddProductsComponent},

    // Shop
    {path:'/shops', component: components.shopComponent},
    {path:'/addShop', component: components.addShopComponent},
    {path:'/editShop/:id', component: components.editShopComponent},
    {path:'/bulkAddShops', component: components.bulkAddShopsComponent},

    // Order
    {path:'/orders', component: components.orderComponent},
    {path:'/orderDetails/:id', component: components.orderDetailsComponent},

    //Corporate Card Components
    {path:'/corporateCard', component: components.corporateCardComponent},
    {path:'/greenlineCard', component: components.greenCardComponent},
    {path:'/fixedTermLoan', component: components.fixedTermLoanComponent},

    // transaction fee routes
    {path: '/onboardingDocuments', component: components.onboardingDocumentsComponent},
    {path: '/addOnboardingDocuments', component: components.addOnboardingDocumentsComponent},
    {path: '/editOnboardingDocuments/:id', component: components.editOnboardingDocumentsComponent},
    
    //New onboarding
    {path: '/addNewCompany', component: components.addNewCompanyComponent},
    {path: '/addNewCompany/:id', component: components.addNewCompanyComponent},
    {path: '/companyDocuments/:id', component: components.companyDocumentsComponent},
    {path: '/onboardingCompanyUsers/:id', component: components.onboardingCompanyUsersComponent},
    
    //Edit onboarding Company
    {path: '/editOnboardedCompany/:id', component: components.editOnboardedCompanyComponent},
    {path: '/editOnboardedCompanyDocuments/:id', component: components.editOnboardedCompanyDocumentsComponent},
    {path: '/editOnboardedCompanyUsers/:id', component: components.editOnboardedCompanyUsersComponent},
    {path: '/companyDetailedView/:id', component: components.companyDetailedViewComponent},
];

let router = new VueRouter({
    mode: 'history',
    routes: routes
});

window.payrollPlusApp = new Vue({
    el: '#payrollPlusApp',
    components: components,
    router: router,
    // store: store, // Add the Vuex store to the Vue instance
});

window.VueComponents = window.payrollPlusApp.$options.components;
// Custom Router Push
window.vueRouterPush = (url) => {
    router.push(url);
}

// Add a 401 response interceptor
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {

        swal.fire({
            title: "Session Expired",
            text: "Your session has expired. Would you like to be redirected to the login page?",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            closeOnConfirm: false,
        })
        .then((result) => {
            if (result.value) {
                window.location = '/login';
            }
        });
        
    } else {
        return Promise.reject(error);
    }
});
